// Detection for IOS devices
const detectIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const getIOSVersion = () => {
  if (!detectIOS()) return null;
  
  const match = navigator.userAgent.match(/OS (\d+)_(\d+)/);
  if (match) {
    return parseFloat(`${match[1]}.${match[2]}`);
  }
  return null;
};

//detection for :has() support
const detectHasSupport = () => {
  try {
    return CSS.supports('selector(:has(span))');
  } catch (e) {
    return false;
  }
};

const shouldUseFallback = () => {
  const isIOS = detectIOS();
  const iosVersion = getIOSVersion();
  const hasSupport = detectHasSupport();
  
  return (isIOS && iosVersion <= 15.3) || !hasSupport;
};


// Component creation functions
const createFallbackTextField = (originalField) => {
  const container = document.createElement('div');
  container.className = 'md-fallback-text-field';
  
  if (originalField.className) {
    container.className += ' ' + originalField.className;
  }
  const label = originalField.getAttribute('label') || '';
  const value = originalField.getAttribute('value') || '';
  const name = originalField.getAttribute('name') || '';
  const type = originalField.getAttribute('type') || 'text';
  const inputmode = originalField.getAttribute('inputmode') || '';
  const required = originalField.hasAttribute('required');
  const supportingText = originalField.getAttribute('supporting-text') || '';
  const errorText = originalField.getAttribute('error-text') || '';
  const hasError = originalField.hasAttribute('error');
  const rows = originalField.getAttribute('rows') || '4';
  const isNumeric = originalField.getAttribute('inputmode') === 'numeric';
  const isTextarea = type === 'textarea';
  const id = originalField.getAttribute('id') || `fallback-${Math.random().toString(36).substr(2, 9)}`;
   if(document.getElementById("date")){
    document.getElementById("date").style.opacity="1";
    document.getElementById("date").style.position="relative";
    document.getElementById("md-fallback-date").style.display="block";
   }
    if(document.getElementById("md-fallback-date-container")){
      document.getElementById("md-fallback-date-container").style.width="100%";
    }
  let inputHTML = '';
  if (isTextarea) {
    inputHTML = `<textarea 
      id="${id}"
      name="${name}"
      rows="${rows}"
      class="md-fallback-input ${hasError ? 'error' : ''}"
      ${required ? 'required' : ''}
      placeholder=" "
    >${value}</textarea>`;
  } else if(id!="open-datepicker") {
    inputHTML = `<input 
      type="${type}"
      id="${id}"
      name="${name}"
      value="${value}"
      class="md-fallback-input${isNumeric ? ' is-number' : ''} ${hasError ? 'error' : ''}"
      ${required ? 'required' : ''}
      ${inputmode ? `inputmode="${inputmode}"` : ''}
      placeholder=" "
    />`;
  }
  if(id!="open-datepicker"){
  container.innerHTML = `
    <div class="md-fallback-field-container ${hasError ? 'error' : ''}">
      ${inputHTML}
      <label class="md-fallback-label ${required ? 'required' : ''} ${value ? 'filled' : ''}" for="${id}">${label}</label>
      ${supportingText || errorText ? `<div class="md-fallback-supporting-text ${hasError ? 'error' : ''}" id="supporting_text-${id}" data-original-text="${supportingText}">${hasError ? errorText : supportingText}</div>` : ''}
    </div>
  `
  };

  Array.from(originalField.attributes).forEach(attr => {
    if (attr.name.startsWith('data-')) {
      container.setAttribute(attr.name, attr.value);
    }
  });

  return container;
};

const createFallbackSelect = (originalSelect) => {
  const container = document.createElement('div');
  container.className = 'md-fallback-select';
  
  if (originalSelect.className) {
    container.className += ' ' 
  }

  const label = originalSelect.getAttribute('label') || '';
  const name = originalSelect.getAttribute('name') || '';
  const required = originalSelect.hasAttribute('required');
  const id = originalSelect.getAttribute('id') || `fallback-${Math.random().toString(36).substr(2, 9)}`;

  const options = Array.from(originalSelect.querySelectorAll('md-select-option')).map(option => ({
    value: option.getAttribute('value') || '',
    text: option.querySelector('[slot="headline"]')?.textContent || option.textContent.trim() || '',
    selected: option.hasAttribute('selected')
  }));

  let optionsHTML = options.length > 0 ? '' : '<option value="">No options available</option>';
  const hasSelectedOption = options.some(option => option.selected);

  options.forEach(option => {
    optionsHTML += `<option value="${option.value}" ${option.selected ? 'selected' : ''}>${option.text}</option>`;
  });

  container.innerHTML = `
    <div class="md-fallback-field-container">
      <select 
        id="${id}"
        name="${name}"
        class="md-fallback-input reload-timetable"
        ${required ? 'required' : ''}
      >
        ${optionsHTML}
      </select>
      <label class="md-fallback-label ${required ? 'required' : ''} ${hasSelectedOption ? 'filled' : ''}" for="${id}">${label}</label>
      <div class="md-fallback-dropdown-icon">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path d="M7 10l5 5 5-5z" fill="currentColor"/>
        </svg>
      </div>
    </div>
  `;

  Array.from(originalSelect.attributes).forEach(attr => {
    if (attr.name.startsWith('data-')) {
      container.setAttribute(attr.name, attr.value);
    }
  });

  const selectElement = container.querySelector('select');
  const labelElement = container.querySelector('.md-fallback-label');
  selectElement.addEventListener('change', () => {

    if (selectElement.value) {
      labelElement.classList.add('filled');
    } else {
      labelElement.classList.remove('filled');
    }
  });

  return container;
};

// Component replacement functions
const replaceTextField = (originalField) => {
  const fallbackField = createFallbackTextField(originalField);
  originalField.parentNode.replaceChild(fallbackField, originalField);
};

const replaceSelect = (originalSelect) => {
  const fallbackSelect = createFallbackSelect(originalSelect);
  originalSelect.parentNode.replaceChild(fallbackSelect, originalSelect);
};

const replaceTextFields = () => {
  const textFields = document.querySelectorAll('md-outlined-text-field');
  textFields.forEach(field => replaceTextField(field));
};

const replaceSelects = () => {
  const selects = document.querySelectorAll('md-outlined-select');
  selects.forEach(select => replaceSelect(select));
};

const replaceMaterialComponents = () => {
  replaceTextFields();
  replaceSelects();
};



const setupMutationObserver = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const textFields = node.querySelectorAll ? node.querySelectorAll('md-outlined-text-field') : [];
          const selects = node.querySelectorAll ? node.querySelectorAll('md-outlined-select') : [];
          
          textFields.forEach(field => replaceTextField(field));
          selects.forEach(select => replaceSelect(select));
          
          if (node.tagName === 'MD-OUTLINED-TEXT-FIELD') {
            replaceTextField(node);
          } else if (node.tagName === 'MD-OUTLINED-SELECT') {
            replaceSelect(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

// Setup and initialization
const setupFallbacks = () => {
  replaceMaterialComponents();
  setupMutationObserver();
};

const initializeFallbacks = () => {
  console.log('Initializing Material Design fallbacks for compatibility');
  
  document.documentElement.classList.add('md-fallback-mode');
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupFallbacks);
  } else {
    setupFallbacks();
  }
};

// Main initialization
const initMaterialFallbackSystem = () => {
  const needsFallback = shouldUseFallback();
  const iosVersion = getIOSVersion();
  if (needsFallback) {
    initializeFallbacks();
  }
  if(iosVersion && (iosVersion<=17 && iosVersion > 15.3)){
    replaceSelects();
    setupMutationObserver();
  }
  return {
    isIOS: detectIOS(),
    iosVersion: getIOSVersion(),
    hasSupport: detectHasSupport(),
    needsFallback
  };
};

// Auto-initialize
// const materialFallback = initMaterialFallbackSystem();

export default initMaterialFallbackSystem;